export const orderPartFormValidator = (formPayload) => {
    let isValid = false;

    const carId = formPayload.carId;
    const vinNumber = formPayload.vinNumber;
    const partDescrtiption = formPayload.partDescrtiption;


    if (carId && vinNumber && partDescrtiption) {
        isValid = true;
    };

    return isValid;
};